export const businessInfo = {
  name: 'Drip Audio LLC',
  phone: '(404) 784-5590',
  rating: 5.0,
  hours: 'Closed Sunday, Opens 10 AM Monday',
  location: 'Forest Park, Georgia',
  serviceArea: ['Forest Park, GA', 'Metro Atlanta', 'Surrounding Areas']
};

export const services = [
  {
    id: 1,
    title: 'Car Stereo Installation',
    description: 'Professional installation of high-quality car stereo systems with precision and care.',
    icon: 'Radio',
    image: 'https://images.unsplash.com/photo-1592570714618-15e2d4719c6c'
  },
  {
    id: 2,
    title: 'Speaker Upgrades',
    description: 'Upgrade your vehicle\'s sound with premium speakers for crystal-clear audio quality.',
    icon: 'Volume2',
    image: 'https://images.unsplash.com/photo-1641264024413-f5e6a9ce2f06'
  },
  {
    id: 3,
    title: 'Bluetooth & Touchscreen Units',
    description: 'Modern touchscreen head units with Bluetooth connectivity for seamless integration.',
    icon: 'Bluetooth',
    image: 'https://images.unsplash.com/photo-1620812736220-df96f172f4ce'
  },
  {
    id: 4,
    title: 'Amplifiers & Subwoofers',
    description: 'Powerful amplifiers and deep bass subwoofers for the ultimate audio experience.',
    icon: 'Waves',
    image: 'https://images.unsplash.com/photo-1760552974114-a83335352b76'
  },
  {
    id: 5,
    title: 'Steering Wheel Control Integration',
    description: 'Keep your hands on the wheel with integrated steering wheel audio controls.',
    icon: 'Disc',
    image: 'https://images.unsplash.com/photo-1755798321153-5ca117077252'
  },
  {
    id: 6,
    title: 'Troubleshooting & Rewiring',
    description: 'Expert diagnosis and repair of audio system issues with professional rewiring.',
    icon: 'Settings',
    image: 'https://images.pexels.com/photos/15646676/pexels-photo-15646676.jpeg'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Mobile Convenience',
    description: 'We come to your home or workplace - no need to visit a shop',
    icon: 'Truck'
  },
  {
    id: 2,
    title: 'Professional Service',
    description: 'Efficient, reliable installation with attention to detail',
    icon: 'Award'
  },
  {
    id: 3,
    title: 'Experienced Installer',
    description: 'Years of expertise in car audio systems and electronics',
    icon: 'Users'
  },
  {
    id: 4,
    title: 'Customer Satisfaction',
    description: '5-star rated service with happy customers across Metro Atlanta',
    icon: 'Star'
  }
];

export const guarantees = [
  {
    id: 1,
    title: '1-Year Workmanship Warranty',
    description: 'Every installation is backed by our comprehensive 1-year warranty on all workmanship',
    icon: 'Shield'
  },
  {
    id: 2,
    title: 'No-Surprise Pricing',
    description: 'Upfront quotes with all costs included before we start any work',
    icon: 'DollarSign'
  },
  {
    id: 3,
    title: 'Lifetime Installation Support',
    description: 'We\'re here for adjustments and help with your system long after installation',
    icon: 'HeadphonesIcon'
  },
  {
    id: 4,
    title: 'Satisfaction Guaranteed',
    description: 'All factory functions maintained or we fix it at no extra charge',
    icon: 'CheckCircle'
  }
];

export const brands = [
  'Pioneer', 'Sony', 'JBL', 'Kenwood', 'Alpine', 
  'Rockford Fosgate', 'Kicker', 'Memphis Audio'
];

export const pricingPackages = [
  {
    id: 1,
    name: 'Basic Package',
    price: 'Starting at $299',
    features: [
      'Single DIN head unit installation',
      'Bluetooth connectivity',
      'Steering wheel control retention',
      'Basic wiring harness included',
      'Same-day installation'
    ],
    popular: false
  },
  {
    id: 2,
    name: 'CarPlay/Android Auto',
    price: 'Starting at $499',
    features: [
      'Apple CarPlay & Android Auto',
      'Double DIN touchscreen unit',
      'Steering wheel control integration',
      'Backup camera compatibility',
      'Premium wiring & dash kit',
      'Professional calibration'
    ],
    popular: true
  },
  {
    id: 3,
    name: 'Premium Audio',
    price: 'Starting at $899',
    features: [
      'Complete speaker upgrade (4-6 speakers)',
      '4-channel amplifier installation',
      '10" subwoofer with enclosure',
      'Sound deadening material',
      'Custom wiring & tuning',
      'Bass remote control'
    ],
    popular: false
  }
];

export const faqs = [
  {
    id: 1,
    question: 'How long does a typical mobile install take?',
    answer: 'Most basic head unit installations take 1-2 hours. Complete audio system upgrades with amplifiers and speakers typically take 3-5 hours. We always provide an estimated timeframe with your quote.'
  },
  {
    id: 2,
    question: 'Do you install customer-supplied equipment?',
    answer: 'Yes! We can install equipment you\'ve purchased. Labor-only installations start at $150. Please note that we can only warranty our installation work, not the equipment itself.'
  },
  {
    id: 3,
    question: 'What do I need to provide for mobile installation?',
    answer: 'Just a driveway or parking space with access to your vehicle. We bring all tools and equipment. Access to a power outlet is helpful but not required for most installations.'
  },
  {
    id: 4,
    question: 'How far in advance should I book?',
    answer: 'We recommend booking 3-5 days in advance, though we often have same-day and next-day availability. Contact us to check our schedule.'
  },
  {
    id: 5,
    question: 'What happens if it rains or weather is bad?',
    answer: 'We can work in covered areas like garages or carports. If weather prevents installation, we\'ll reschedule at no charge.'
  },
  {
    id: 6,
    question: 'Do you warranty your work?',
    answer: 'Absolutely! Every installation includes a 1-year workmanship warranty. We also honor manufacturer warranties on all equipment we supply.'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Michael Thompson',
    rating: 5,
    text: 'His work is top-notch, and I couldn\'t be happier with the results. Professional installation and great sound quality!',
    date: 'March 2024'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    rating: 5,
    text: 'Expert service! The mobile convenience made it so easy. My car audio system sounds amazing now.',
    date: 'February 2024'
  },
  {
    id: 3,
    name: 'David Miller',
    rating: 5,
    text: 'Highly recommend Drip Audio! Quick, professional, and the sound system installation was flawless.',
    date: 'January 2024'
  },
  {
    id: 4,
    name: 'Jennifer Lee',
    rating: 5,
    text: 'Best car audio installer in Atlanta! Came to my house and did an incredible job. Very satisfied!',
    date: 'December 2023'
  }
];

export const contactFormFields = {
  name: '',
  phone: '',
  vehicle: '',
  service: '',
  message: ''
};

export const certifications = [
  {
    id: 1,
    name: 'MECP Certified',
    description: 'Mobile Electronics Certified Professional',
    icon: 'Award'
  },
  {
    id: 2,
    name: 'Insured & Bonded',
    description: 'Fully insured business operations',
    icon: 'Shield'
  },
  {
    id: 3,
    name: 'BBB Accredited',
    description: 'Better Business Bureau A+ Rating',
    icon: 'CheckCircle'
  }
];

export const howItWorks = [
  {
    id: 1,
    step: '01',
    title: 'Share Your Details',
    description: 'Tell us your vehicle info and what audio upgrade you need. Get instant quote online or over the phone.',
    icon: 'FileText'
  },
  {
    id: 2,
    step: '02',
    title: 'We Come to You',
    description: 'Schedule a convenient time. We arrive at your home or office with all professional tools and equipment.',
    icon: 'Truck'
  },
  {
    id: 3,
    step: '03',
    title: 'Expert Installation',
    description: 'Our certified technician installs your system with precision. Clean, professional work guaranteed.',
    icon: 'Settings'
  },
  {
    id: 4,
    step: '04',
    title: 'Enjoy Premium Sound',
    description: 'Test your new system, get a full tutorial. Drive away with incredible audio and lifetime support.',
    icon: 'Volume2'
  }
];

export const stats = [
  { number: '500+', label: 'Installations Completed' },
  { number: '5.0', label: 'Google Rating' },
  { number: '100%', label: 'Satisfaction Rate' },
  { number: '<2hr', label: 'Average Install Time' }
];